import InfoMessageListResourcePagingResultModel from '../../generated/types/model/resource/InfoMessageListResourcePagingResultModel';

export default class InfoMessageListResourcePagingResultViewModel extends InfoMessageListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
